// Traductions dédiées à l'espace Postinity (« De mon vivant »).
// Fusionnées dans chaque langue au niveau de i18n/index.js.
// Namespace: clé "po".

const fr = {
  back_profile: "Profil",
  title: "Je prépare ma cérémonie",
  subtitle: "Préparez de votre vivant votre hommage et vos messages, pour laisser à ceux que vous aimez un dernier souffle de tendresse.",
  concept_h: "Le concept",
  concept1_t: "1 — Préparez GRATUITEMENT votre cérémonie du souvenir",
  concept1_d: "De votre vivant, créez un hommage à votre image : bougie, texte, photos, vidéo, musique, documents et messages privés pour vos proches. Vous choisissez tout et pouvez tout modifier à tout moment, gratuitement.",
  concept2_t: "2 — Vos trois garants veillent GRATUITEMENT sur vos volontés",
  concept2_d: "Le moment venu, vos trois personnes garantes confirment votre décès et déclenchent gratuitement la procédure de vérification.",
  concept3_t: "3 — Postinity transmet GRATUITEMENT votre héritage numérique",
  concept3_d: "Après contrôle, Postinity transmet gratuitement vos messages privés à leurs destinataires et publie l'hommage que vous avez préparé.",
  free_h: "Pourquoi la préparation est gratuite",
  free_p1: "Préparer votre cérémonie du souvenir avec Postinity est entièrement gratuit, parce que nous pensons que chacun doit pouvoir préparer, protéger et transmettre ses souvenirs et ses mots, sans contrainte financière de son vivant. Vous ne payez rien pour créer votre espace, préparer votre bougie, ajouter vos photos, vidéos, musiques, documents et messages privés, les modifier ou les conserver en toute sécurité.",
  free_p2: "Vos trois garants n'ont également rien à payer pour confirmer votre décès et déclencher la procédure de vérification.",
  free_p3: "Postinity se rémunère uniquement le moment venu, lors de la diffusion de votre cérémonie du souvenir et de la transmission effective de vos messages à leurs destinataires.",
  free_tag1: "Vous préparez gratuitement aujourd'hui.",
  free_tag2: "Postinity prend le relais le moment venu.",
  pricing_link: "Tarifs à consulter",
  free_block_title: "Gratuit pour la personne qui dépose ses messages",
  free_block_sub: "Vous ne payez rien pour préparer",
  card_ceremony: "Ma cérémonie",
  card_message: "Par message individuel",
  free_ceremony_desc: "Préparez et modifiez librement votre cérémonie, de votre vivant.",
  free_message_desc: "Écrivez et enregistrez autant de messages privés que vous voulez.",
  pay_btn: "Je règle ma cérémonie & messages",
  paid_block_title: "Tout est à la charge des personnes qui voudront consulter vos messages",
  paid_block_sub: "Les tarifs, en toute transparence",
  ceremony_paid_desc: "Mise au coffre-fort numérique et diffusion de votre cérémonie le moment venu.",
  message_paid_desc: "Pour chaque message privé transmis à la personne de votre choix.",
  free_footer: "La préparation reste gratuite — vous ne réglez rien aujourd'hui.",
  start_btn: "Je prépare ma cérémonie",
  // Tableau de commande
  order_title: "Régler ma cérémonie & mes messages",
  order_ceremony_desc: "Une seule cérémonie, transmise à vos garants le moment venu.",
  order_already_paid: "Déjà réglée",
  order_messages: "Messages individuels",
  order_per_message: "/ message",
  order_bundles: "Offres par lot",
  order_bonus: "(+{{n}} offert)",
  order_total: "Total à régler",
  order_summary: "{{n}} message(s) prépayé(s)",
  order_plus_ceremony: " + cérémonie",
  order_note: "Le prépaiement crée un crédit : votre cérémonie et vos messages seront déjà réglés, gratuits pour vos proches.",
  order_cancel: "Annuler",
  order_pay: "Payer",
  order_success: "Prépaiement enregistré 🎉",
  order_error: "Paiement impossible",
  // Bannière crédits (préparation)
  credits_some: "{{n}} message(s) prépayé(s) — offert(s) à vos proches",
  credits_none: "Aucun crédit : vos nouveaux messages seront à la charge du destinataire. Prépayez-les pour les offrir.",
  credits_buy: "Régler mes messages",
};

const en = {
  back_profile: "Profile",
  title: "I prepare my ceremony",
  subtitle: "Prepare your tribute and your messages while you are alive, to leave those you love one last breath of tenderness.",
  concept_h: "The concept",
  concept1_t: "1 — Prepare your memorial ceremony FOR FREE",
  concept1_d: "While you are alive, create a tribute in your image: candle, text, photos, video, music, documents and private messages for your loved ones. You choose everything and can change it at any time, for free.",
  concept2_t: "2 — Your three guardians watch over your wishes FOR FREE",
  concept2_d: "When the time comes, your three guardians confirm your passing and trigger the verification process, free of charge.",
  concept3_t: "3 — Postinity delivers your digital legacy FOR FREE",
  concept3_d: "After verification, Postinity delivers your private messages to their recipients for free and publishes the tribute you prepared.",
  free_h: "Why preparation is free",
  free_p1: "Preparing your memorial ceremony with Postinity is entirely free, because we believe everyone should be able to prepare, protect and pass on their memories and words, without financial constraints during their lifetime. You pay nothing to create your space, prepare your candle, add your photos, videos, music, documents and private messages, edit them or keep them safely.",
  free_p2: "Your three guardians also have nothing to pay to confirm your passing and start the verification process.",
  free_p3: "Postinity is paid only when the time comes, upon the broadcast of your memorial ceremony and the actual delivery of your messages to their recipients.",
  free_tag1: "You prepare for free today.",
  free_tag2: "Postinity takes over when the time comes.",
  pricing_link: "View pricing",
  free_block_title: "Free for the person who leaves the messages",
  free_block_sub: "You pay nothing to prepare",
  card_ceremony: "My ceremony",
  card_message: "Per individual message",
  free_ceremony_desc: "Prepare and edit your ceremony freely, during your lifetime.",
  free_message_desc: "Write and save as many private messages as you like.",
  pay_btn: "I pay for my ceremony & messages",
  paid_block_title: "Everything is paid by the people who wish to view your messages",
  paid_block_sub: "Our pricing, fully transparent",
  ceremony_paid_desc: "Stored in the digital vault and broadcast of your ceremony when the time comes.",
  message_paid_desc: "For each private message delivered to the person of your choice.",
  free_footer: "Preparation stays free — you pay nothing today.",
  start_btn: "I prepare my ceremony",
  order_title: "Pay for my ceremony & my messages",
  order_ceremony_desc: "A single ceremony, delivered to your guardians when the time comes.",
  order_already_paid: "Already paid",
  order_messages: "Individual messages",
  order_per_message: "/ message",
  order_bundles: "Bundle offers",
  order_bonus: "(+{{n}} free)",
  order_total: "Total to pay",
  order_summary: "{{n}} prepaid message(s)",
  order_plus_ceremony: " + ceremony",
  order_note: "Prepayment creates a credit: your ceremony and messages will already be paid, free for your loved ones.",
  order_cancel: "Cancel",
  order_pay: "Pay",
  order_success: "Prepayment recorded 🎉",
  order_error: "Payment failed",
  credits_some: "{{n}} prepaid message(s) — offered to your loved ones",
  credits_none: "No credit: your new messages will be paid by the recipient. Prepay them to offer them.",
  credits_buy: "Pay for my messages",
};

const es = {
  back_profile: "Perfil",
  title: "Preparo mi ceremonia",
  subtitle: "Prepara en vida tu homenaje y tus mensajes, para dejar a quienes amas un último soplo de ternura.",
  concept_h: "El concepto",
  concept1_t: "1 — Prepara GRATIS tu ceremonia del recuerdo",
  concept1_d: "En vida, crea un homenaje a tu imagen: vela, texto, fotos, vídeo, música, documentos y mensajes privados para tus seres queridos. Tú eliges todo y puedes modificarlo en cualquier momento, gratis.",
  concept2_t: "2 — Tus tres garantes velan GRATIS por tus voluntades",
  concept2_d: "Llegado el momento, tus tres garantes confirman tu fallecimiento y activan gratuitamente el procedimiento de verificación.",
  concept3_t: "3 — Postinity transmite GRATIS tu herencia digital",
  concept3_d: "Tras la comprobación, Postinity transmite gratuitamente tus mensajes privados a sus destinatarios y publica el homenaje que preparaste.",
  free_h: "Por qué la preparación es gratuita",
  free_p1: "Preparar tu ceremonia del recuerdo con Postinity es totalmente gratis, porque creemos que todos deben poder preparar, proteger y transmitir sus recuerdos y palabras, sin cargas económicas en vida. No pagas nada por crear tu espacio, preparar tu vela, añadir fotos, vídeos, música, documentos y mensajes privados, modificarlos o conservarlos con seguridad.",
  free_p2: "Tus tres garantes tampoco pagan nada por confirmar tu fallecimiento y activar el procedimiento de verificación.",
  free_p3: "Postinity solo cobra llegado el momento, al difundir tu ceremonia del recuerdo y entregar efectivamente tus mensajes a sus destinatarios.",
  free_tag1: "Preparas gratis hoy.",
  free_tag2: "Postinity toma el relevo llegado el momento.",
  pricing_link: "Ver tarifas",
  free_block_title: "Gratis para quien deja los mensajes",
  free_block_sub: "No pagas nada por preparar",
  card_ceremony: "Mi ceremonia",
  card_message: "Por mensaje individual",
  free_ceremony_desc: "Prepara y modifica libremente tu ceremonia, en vida.",
  free_message_desc: "Escribe y guarda tantos mensajes privados como quieras.",
  pay_btn: "Pago mi ceremonia y mensajes",
  paid_block_title: "Todo corre a cargo de quienes quieran consultar tus mensajes",
  paid_block_sub: "Las tarifas, con total transparencia",
  ceremony_paid_desc: "Guardado en la caja fuerte digital y difusión de tu ceremonia llegado el momento.",
  message_paid_desc: "Por cada mensaje privado entregado a la persona que elijas.",
  free_footer: "La preparación sigue siendo gratis — hoy no pagas nada.",
  start_btn: "Preparo mi ceremonia",
  order_title: "Pagar mi ceremonia y mis mensajes",
  order_ceremony_desc: "Una sola ceremonia, entregada a tus garantes llegado el momento.",
  order_already_paid: "Ya pagada",
  order_messages: "Mensajes individuales",
  order_per_message: "/ mensaje",
  order_bundles: "Ofertas por lote",
  order_bonus: "(+{{n}} gratis)",
  order_total: "Total a pagar",
  order_summary: "{{n}} mensaje(s) prepagado(s)",
  order_plus_ceremony: " + ceremonia",
  order_note: "El prepago crea un crédito: tu ceremonia y tus mensajes ya estarán pagados, gratis para tus seres queridos.",
  order_cancel: "Cancelar",
  order_pay: "Pagar",
  order_success: "Prepago registrado 🎉",
  order_error: "Pago imposible",
  credits_some: "{{n}} mensaje(s) prepagado(s) — ofrecido(s) a tus seres queridos",
  credits_none: "Sin crédito: tus nuevos mensajes correrán a cargo del destinatario. Prepágalos para ofrecerlos.",
  credits_buy: "Pagar mis mensajes",
};

const de = {
  back_profile: "Profil",
  title: "Ich bereite meine Zeremonie vor",
  subtitle: "Bereiten Sie zu Lebzeiten Ihre Hommage und Ihre Nachrichten vor, um Ihren Liebsten einen letzten Hauch von Zärtlichkeit zu hinterlassen.",
  concept_h: "Das Konzept",
  concept1_t: "1 — Bereiten Sie Ihre Gedenkzeremonie KOSTENLOS vor",
  concept1_d: "Erstellen Sie zu Lebzeiten eine Hommage nach Ihrem Bild: Kerze, Text, Fotos, Video, Musik, Dokumente und private Nachrichten für Ihre Angehörigen. Sie wählen alles und können jederzeit kostenlos alles ändern.",
  concept2_t: "2 — Ihre drei Bürgen wachen KOSTENLOS über Ihren Willen",
  concept2_d: "Wenn es so weit ist, bestätigen Ihre drei Bürgen Ihren Tod und lösen kostenlos das Prüfverfahren aus.",
  concept3_t: "3 — Postinity übergibt Ihr digitales Erbe KOSTENLOS",
  concept3_d: "Nach der Prüfung übermittelt Postinity Ihre privaten Nachrichten kostenlos an ihre Empfänger und veröffentlicht die von Ihnen vorbereitete Hommage.",
  free_h: "Warum die Vorbereitung kostenlos ist",
  free_p1: "Die Vorbereitung Ihrer Gedenkzeremonie mit Postinity ist völlig kostenlos, weil wir glauben, dass jeder seine Erinnerungen und Worte zu Lebzeiten ohne finanzielle Zwänge vorbereiten, schützen und weitergeben können sollte. Sie zahlen nichts, um Ihren Bereich zu erstellen, Ihre Kerze vorzubereiten, Ihre Fotos, Videos, Musik, Dokumente und privaten Nachrichten hinzuzufügen, zu ändern oder sicher aufzubewahren.",
  free_p2: "Auch Ihre drei Bürgen müssen nichts zahlen, um Ihren Tod zu bestätigen und das Prüfverfahren zu starten.",
  free_p3: "Postinity wird erst dann bezahlt, wenn es so weit ist – bei der Ausstrahlung Ihrer Gedenkzeremonie und der tatsächlichen Übermittlung Ihrer Nachrichten an die Empfänger.",
  free_tag1: "Heute bereiten Sie kostenlos vor.",
  free_tag2: "Postinity übernimmt, wenn es so weit ist.",
  pricing_link: "Preise ansehen",
  free_block_title: "Kostenlos für die Person, die die Nachrichten hinterlässt",
  free_block_sub: "Für die Vorbereitung zahlen Sie nichts",
  card_ceremony: "Meine Zeremonie",
  card_message: "Pro einzelne Nachricht",
  free_ceremony_desc: "Bereiten Sie Ihre Zeremonie frei vor und ändern Sie sie, zu Lebzeiten.",
  free_message_desc: "Schreiben und speichern Sie so viele private Nachrichten, wie Sie möchten.",
  pay_btn: "Ich bezahle meine Zeremonie & Nachrichten",
  paid_block_title: "Alles trägt, wer Ihre Nachrichten einsehen möchte",
  paid_block_sub: "Die Preise, ganz transparent",
  ceremony_paid_desc: "Ablage im digitalen Safe und Ausstrahlung Ihrer Zeremonie, wenn es so weit ist.",
  message_paid_desc: "Für jede private Nachricht, die an die Person Ihrer Wahl übermittelt wird.",
  free_footer: "Die Vorbereitung bleibt kostenlos — heute zahlen Sie nichts.",
  start_btn: "Ich bereite meine Zeremonie vor",
  order_title: "Meine Zeremonie & meine Nachrichten bezahlen",
  order_ceremony_desc: "Eine einzige Zeremonie, die Ihren Bürgen übergeben wird, wenn es so weit ist.",
  order_already_paid: "Bereits bezahlt",
  order_messages: "Einzelne Nachrichten",
  order_per_message: "/ Nachricht",
  order_bundles: "Paketangebote",
  order_bonus: "(+{{n}} gratis)",
  order_total: "Gesamtbetrag",
  order_summary: "{{n}} vorausbezahlte Nachricht(en)",
  order_plus_ceremony: " + Zeremonie",
  order_note: "Die Vorauszahlung erzeugt ein Guthaben: Ihre Zeremonie und Nachrichten sind bereits bezahlt, kostenlos für Ihre Angehörigen.",
  order_cancel: "Abbrechen",
  order_pay: "Bezahlen",
  order_success: "Vorauszahlung erfasst 🎉",
  order_error: "Zahlung fehlgeschlagen",
  credits_some: "{{n}} vorausbezahlte Nachricht(en) — für Ihre Angehörigen geschenkt",
  credits_none: "Kein Guthaben: Ihre neuen Nachrichten trägt der Empfänger. Zahlen Sie im Voraus, um sie zu schenken.",
  credits_buy: "Meine Nachrichten bezahlen",
};

const it = {
  back_profile: "Profilo",
  title: "Preparo la mia cerimonia",
  subtitle: "Prepara in vita il tuo omaggio e i tuoi messaggi, per lasciare a chi ami un ultimo soffio di tenerezza.",
  concept_h: "Il concetto",
  concept1_t: "1 — Prepara GRATIS la tua cerimonia del ricordo",
  concept1_d: "In vita, crea un omaggio a tua immagine: candela, testo, foto, video, musica, documenti e messaggi privati per i tuoi cari. Scegli tutto e puoi modificarlo in qualsiasi momento, gratis.",
  concept2_t: "2 — I tuoi tre garanti vegliano GRATIS sulle tue volontà",
  concept2_d: "Al momento opportuno, i tuoi tre garanti confermano il tuo decesso e avviano gratuitamente la procedura di verifica.",
  concept3_t: "3 — Postinity trasmette GRATIS la tua eredità digitale",
  concept3_d: "Dopo la verifica, Postinity trasmette gratuitamente i tuoi messaggi privati ai destinatari e pubblica l'omaggio che hai preparato.",
  free_h: "Perché la preparazione è gratuita",
  free_p1: "Preparare la tua cerimonia del ricordo con Postinity è del tutto gratuito, perché crediamo che ognuno debba poter preparare, proteggere e trasmettere i propri ricordi e le proprie parole, senza vincoli economici in vita. Non paghi nulla per creare il tuo spazio, preparare la candela, aggiungere foto, video, musica, documenti e messaggi privati, modificarli o conservarli in sicurezza.",
  free_p2: "Anche i tuoi tre garanti non pagano nulla per confermare il tuo decesso e avviare la procedura di verifica.",
  free_p3: "Postinity viene retribuita solo al momento opportuno, con la diffusione della tua cerimonia del ricordo e la consegna effettiva dei tuoi messaggi ai destinatari.",
  free_tag1: "Oggi prepari gratis.",
  free_tag2: "Postinity subentra al momento opportuno.",
  pricing_link: "Vedi le tariffe",
  free_block_title: "Gratis per chi deposita i messaggi",
  free_block_sub: "Non paghi nulla per preparare",
  card_ceremony: "La mia cerimonia",
  card_message: "Per messaggio individuale",
  free_ceremony_desc: "Prepara e modifica liberamente la tua cerimonia, in vita.",
  free_message_desc: "Scrivi e salva tutti i messaggi privati che vuoi.",
  pay_btn: "Pago la mia cerimonia e i messaggi",
  paid_block_title: "Tutto è a carico di chi vorrà consultare i tuoi messaggi",
  paid_block_sub: "Le tariffe, in piena trasparenza",
  ceremony_paid_desc: "Messa nella cassaforte digitale e diffusione della tua cerimonia al momento opportuno.",
  message_paid_desc: "Per ogni messaggio privato consegnato alla persona che scegli.",
  free_footer: "La preparazione resta gratuita — oggi non paghi nulla.",
  start_btn: "Preparo la mia cerimonia",
  order_title: "Pagare la mia cerimonia e i miei messaggi",
  order_ceremony_desc: "Una sola cerimonia, consegnata ai tuoi garanti al momento opportuno.",
  order_already_paid: "Già pagata",
  order_messages: "Messaggi individuali",
  order_per_message: "/ messaggio",
  order_bundles: "Offerte a pacchetto",
  order_bonus: "(+{{n}} gratis)",
  order_total: "Totale da pagare",
  order_summary: "{{n}} messaggio/i prepagato/i",
  order_plus_ceremony: " + cerimonia",
  order_note: "Il prepagamento crea un credito: la tua cerimonia e i messaggi saranno già pagati, gratis per i tuoi cari.",
  order_cancel: "Annulla",
  order_pay: "Paga",
  order_success: "Prepagamento registrato 🎉",
  order_error: "Pagamento non riuscito",
  credits_some: "{{n}} messaggio/i prepagato/i — offerto/i ai tuoi cari",
  credits_none: "Nessun credito: i nuovi messaggi saranno a carico del destinatario. Prepagali per offrirli.",
  credits_buy: "Pago i miei messaggi",
};

const pl = {
  back_profile: "Profil",
  title: "Przygotowuję moją ceremonię",
  subtitle: "Przygotuj za życia swój hołd i wiadomości, aby zostawić bliskim ostatnie tchnienie czułości.",
  concept_h: "Koncepcja",
  concept1_t: "1 — Przygotuj ZA DARMO swoją ceremonię pamięci",
  concept1_d: "Za życia stwórz hołd na swój obraz: świeca, tekst, zdjęcia, wideo, muzyka, dokumenty i prywatne wiadomości dla bliskich. Wybierasz wszystko i możesz to w każdej chwili bezpłatnie zmienić.",
  concept2_t: "2 — Twoich trzech gwarantów ZA DARMO czuwa nad Twoją wolą",
  concept2_d: "Gdy nadejdzie czas, trzej gwaranci potwierdzają Twój zgon i bezpłatnie uruchamiają procedurę weryfikacji.",
  concept3_t: "3 — Postinity ZA DARMO przekazuje Twoje dziedzictwo cyfrowe",
  concept3_d: "Po weryfikacji Postinity bezpłatnie przekazuje Twoje prywatne wiadomości odbiorcom i publikuje przygotowany przez Ciebie hołd.",
  free_h: "Dlaczego przygotowanie jest bezpłatne",
  free_p1: "Przygotowanie ceremonii pamięci z Postinity jest całkowicie bezpłatne, ponieważ uważamy, że każdy powinien móc przygotować, chronić i przekazać swoje wspomnienia i słowa, bez obciążeń finansowych za życia. Nic nie płacisz za utworzenie przestrzeni, przygotowanie świecy, dodanie zdjęć, filmów, muzyki, dokumentów i prywatnych wiadomości, ich zmianę czy bezpieczne przechowywanie.",
  free_p2: "Twoich trzech gwarantów również nic nie płaci za potwierdzenie zgonu i uruchomienie procedury weryfikacji.",
  free_p3: "Postinity otrzymuje wynagrodzenie dopiero, gdy nadejdzie czas — przy udostępnieniu ceremonii pamięci i faktycznym przekazaniu wiadomości odbiorcom.",
  free_tag1: "Dziś przygotowujesz za darmo.",
  free_tag2: "Postinity przejmuje, gdy nadejdzie czas.",
  pricing_link: "Zobacz cennik",
  free_block_title: "Bezpłatnie dla osoby, która zostawia wiadomości",
  free_block_sub: "Za przygotowanie nic nie płacisz",
  card_ceremony: "Moja ceremonia",
  card_message: "Za pojedynczą wiadomość",
  free_ceremony_desc: "Przygotuj i dowolnie zmieniaj swoją ceremonię, za życia.",
  free_message_desc: "Pisz i zapisuj dowolną liczbę prywatnych wiadomości.",
  pay_btn: "Opłacam ceremonię i wiadomości",
  paid_block_title: "Wszystko pokrywają osoby, które zechcą zobaczyć Twoje wiadomości",
  paid_block_sub: "Cennik, w pełnej przejrzystości",
  ceremony_paid_desc: "Zapis w cyfrowym sejfie i udostępnienie ceremonii, gdy nadejdzie czas.",
  message_paid_desc: "Za każdą prywatną wiadomość przekazaną wybranej osobie.",
  free_footer: "Przygotowanie pozostaje bezpłatne — dziś nic nie płacisz.",
  start_btn: "Przygotowuję moją ceremonię",
  order_title: "Opłać moją ceremonię i wiadomości",
  order_ceremony_desc: "Jedna ceremonia, przekazana gwarantom, gdy nadejdzie czas.",
  order_already_paid: "Już opłacona",
  order_messages: "Wiadomości indywidualne",
  order_per_message: "/ wiadomość",
  order_bundles: "Oferty pakietowe",
  order_bonus: "(+{{n}} gratis)",
  order_total: "Razem do zapłaty",
  order_summary: "{{n}} opłaconych z góry wiadomości",
  order_plus_ceremony: " + ceremonia",
  order_note: "Przedpłata tworzy kredyt: ceremonia i wiadomości będą już opłacone, bezpłatne dla Twoich bliskich.",
  order_cancel: "Anuluj",
  order_pay: "Zapłać",
  order_success: "Przedpłata zapisana 🎉",
  order_error: "Płatność nieudana",
  credits_some: "{{n}} opłaconych z góry wiadomości — podarowane bliskim",
  credits_none: "Brak kredytu: nowe wiadomości pokryje odbiorca. Opłać je z góry, aby je podarować.",
  credits_buy: "Opłać moje wiadomości",
};

const fil = {
  back_profile: "Profile",
  title: "Inihahanda ko ang aking seremonya",
  subtitle: "Habang buhay, ihanda ang iyong parangal at mga mensahe, upang mag-iwan sa mga mahal mo ng huling hininga ng lambing.",
  concept_h: "Ang konsepto",
  concept1_t: "1 — Ihanda nang LIBRE ang iyong seremonya ng pag-alaala",
  concept1_d: "Habang buhay, lumikha ng parangal ayon sa iyong sarili: kandila, teksto, larawan, video, musika, dokumento at pribadong mensahe para sa mga mahal mo. Ikaw ang pumipili ng lahat at maaari mong baguhin anumang oras, nang libre.",
  concept2_t: "2 — Ang tatlong tagapangalaga ay LIBRENG magbabantay sa iyong kagustuhan",
  concept2_d: "Sa takdang panahon, kinukumpirma ng iyong tatlong tagapangalaga ang iyong pagpanaw at libreng sisimulan ang proseso ng pagpapatunay.",
  concept3_t: "3 — LIBRENG ipinapasa ng Postinity ang iyong digital na pamana",
  concept3_d: "Pagkatapos ng pagsusuri, libreng ipinapasa ng Postinity ang iyong mga pribadong mensahe sa mga tatanggap at inilalathala ang parangal na inihanda mo.",
  free_h: "Bakit libre ang paghahanda",
  free_p1: "Ang paghahanda ng iyong seremonya ng pag-alaala sa Postinity ay ganap na libre, dahil naniniwala kami na dapat magawa ng bawat isa na ihanda, protektahan at ipasa ang kanilang mga alaala at salita, nang walang pasaning pinansyal habang buhay. Wala kang babayaran para gumawa ng espasyo, maghanda ng kandila, magdagdag ng larawan, video, musika, dokumento at pribadong mensahe, baguhin o ligtas na itago ang mga ito.",
  free_p2: "Ang iyong tatlong tagapangalaga ay wala ring babayaran para kumpirmahin ang iyong pagpanaw at simulan ang proseso ng pagpapatunay.",
  free_p3: "Binabayaran lamang ang Postinity sa takdang panahon, sa pagpapalabas ng iyong seremonya ng pag-alaala at sa aktwal na paghahatid ng iyong mga mensahe sa mga tatanggap.",
  free_tag1: "Libre kang naghahanda ngayon.",
  free_tag2: "Susunod ang Postinity sa takdang panahon.",
  pricing_link: "Tingnan ang presyo",
  free_block_title: "Libre para sa taong nag-iiwan ng mga mensahe",
  free_block_sub: "Wala kang babayaran para maghanda",
  card_ceremony: "Aking seremonya",
  card_message: "Bawat indibidwal na mensahe",
  free_ceremony_desc: "Ihanda at baguhin nang malaya ang iyong seremonya, habang buhay.",
  free_message_desc: "Sumulat at mag-save ng kasindaming pribadong mensahe ayon sa gusto mo.",
  pay_btn: "Babayaran ko ang seremonya at mensahe",
  paid_block_title: "Lahat ay sagot ng mga taong gustong tingnan ang iyong mga mensahe",
  paid_block_sub: "Ang presyo, ganap na malinaw",
  ceremony_paid_desc: "Nakaimbak sa digital vault at ipapalabas ang seremonya sa takdang panahon.",
  message_paid_desc: "Para sa bawat pribadong mensaheng ihahatid sa taong pipiliin mo.",
  free_footer: "Nananatiling libre ang paghahanda — wala kang babayaran ngayon.",
  start_btn: "Inihahanda ko ang aking seremonya",
  order_title: "Bayaran ang aking seremonya at mga mensahe",
  order_ceremony_desc: "Iisang seremonya, ihahatid sa iyong mga tagapangalaga sa takdang panahon.",
  order_already_paid: "Bayad na",
  order_messages: "Mga indibidwal na mensahe",
  order_per_message: "/ mensahe",
  order_bundles: "Mga alok na bundle",
  order_bonus: "(+{{n}} libre)",
  order_total: "Kabuuang babayaran",
  order_summary: "{{n}} bayad-nang-maaga na mensahe",
  order_plus_ceremony: " + seremonya",
  order_note: "Ang paunang bayad ay gumagawa ng credit: bayad na ang iyong seremonya at mga mensahe, libre para sa iyong mga mahal.",
  order_cancel: "Kanselahin",
  order_pay: "Magbayad",
  order_success: "Naitala ang paunang bayad 🎉",
  order_error: "Hindi matuloy ang bayad",
  credits_some: "{{n}} bayad-nang-maaga na mensahe — regalo sa iyong mga mahal",
  credits_none: "Walang credit: ang bagong mensahe ay sagot ng tatanggap. Bayaran nang maaga upang iregalo.",
  credits_buy: "Bayaran ang aking mensahe",
};

const ru = {
  back_profile: "Профиль",
  title: "Я готовлю свою церемонию",
  subtitle: "Подготовьте при жизни свою дань памяти и послания, чтобы оставить близким последнее дыхание нежности.",
  concept_h: "Концепция",
  concept1_t: "1 — Подготовьте БЕСПЛАТНО свою церемонию памяти",
  concept1_d: "При жизни создайте дань памяти по своему образу: свеча, текст, фото, видео, музыка, документы и личные послания для близких. Вы выбираете всё и можете в любой момент бесплатно изменить.",
  concept2_t: "2 — Три ваших поручителя БЕСПЛАТНО следят за вашей волей",
  concept2_d: "Когда придёт время, три поручителя подтверждают вашу кончину и бесплатно запускают процедуру проверки.",
  concept3_t: "3 — Postinity БЕСПЛАТНО передаёт ваше цифровое наследие",
  concept3_d: "После проверки Postinity бесплатно передаёт ваши личные послания получателям и публикует подготовленную вами дань памяти.",
  free_h: "Почему подготовка бесплатна",
  free_p1: "Подготовка церемонии памяти с Postinity полностью бесплатна, потому что мы считаем, что каждый должен иметь возможность подготовить, защитить и передать свои воспоминания и слова без финансовых ограничений при жизни. Вы ничего не платите за создание пространства, подготовку свечи, добавление фото, видео, музыки, документов и личных посланий, их изменение или безопасное хранение.",
  free_p2: "Три ваших поручителя также ничего не платят за подтверждение кончины и запуск процедуры проверки.",
  free_p3: "Postinity получает оплату только когда придёт время — при трансляции церемонии памяти и фактической передаче ваших посланий получателям.",
  free_tag1: "Сегодня вы готовите бесплатно.",
  free_tag2: "Postinity подхватывает, когда придёт время.",
  pricing_link: "Посмотреть тарифы",
  free_block_title: "Бесплатно для того, кто оставляет послания",
  free_block_sub: "За подготовку вы ничего не платите",
  card_ceremony: "Моя церемония",
  card_message: "За отдельное послание",
  free_ceremony_desc: "Готовьте и свободно меняйте свою церемонию при жизни.",
  free_message_desc: "Пишите и сохраняйте сколько угодно личных посланий.",
  pay_btn: "Оплачиваю церемонию и послания",
  paid_block_title: "Всё оплачивают те, кто захочет просмотреть ваши послания",
  paid_block_sub: "Тарифы, полностью прозрачно",
  ceremony_paid_desc: "Хранение в цифровом сейфе и трансляция церемонии, когда придёт время.",
  message_paid_desc: "За каждое личное послание, переданное выбранному вами человеку.",
  free_footer: "Подготовка остаётся бесплатной — сегодня вы ничего не платите.",
  start_btn: "Я готовлю свою церемонию",
  order_title: "Оплатить церемонию и послания",
  order_ceremony_desc: "Одна церемония, передаётся вашим поручителям, когда придёт время.",
  order_already_paid: "Уже оплачено",
  order_messages: "Отдельные послания",
  order_per_message: "/ послание",
  order_bundles: "Пакетные предложения",
  order_bonus: "(+{{n}} бесплатно)",
  order_total: "Итого к оплате",
  order_summary: "{{n}} предоплаченных посланий",
  order_plus_ceremony: " + церемония",
  order_note: "Предоплата создаёт кредит: церемония и послания уже оплачены, бесплатно для ваших близких.",
  order_cancel: "Отмена",
  order_pay: "Оплатить",
  order_success: "Предоплата сохранена 🎉",
  order_error: "Оплата невозможна",
  credits_some: "{{n}} предоплаченных посланий — подарены вашим близким",
  credits_none: "Нет кредита: новые послания оплатит получатель. Оплатите заранее, чтобы подарить их.",
  credits_buy: "Оплатить мои послания",
};

const el = {
  back_profile: "Προφίλ",
  title: "Ετοιμάζω την τελετή μου",
  subtitle: "Ετοιμάστε όσο ζείτε τον φόρο τιμής και τα μηνύματά σας, για να αφήσετε σε όσους αγαπάτε μια τελευταία πνοή τρυφερότητας.",
  concept_h: "Η ιδέα",
  concept1_t: "1 — Ετοιμάστε ΔΩΡΕΑΝ την τελετή μνήμης σας",
  concept1_d: "Όσο ζείτε, δημιουργήστε έναν φόρο τιμής στο μέτρο σας: κερί, κείμενο, φωτογραφίες, βίντεο, μουσική, έγγραφα και ιδιωτικά μηνύματα για τους αγαπημένους σας. Επιλέγετε τα πάντα και μπορείτε να τα αλλάξετε ανά πάσα στιγμή, δωρεάν.",
  concept2_t: "2 — Οι τρεις εγγυητές σας φροντίζουν ΔΩΡΕΑΝ τη θέλησή σας",
  concept2_d: "Όταν έρθει η ώρα, οι τρεις εγγυητές επιβεβαιώνουν τον θάνατό σας και ξεκινούν δωρεάν τη διαδικασία επαλήθευσης.",
  concept3_t: "3 — Η Postinity μεταβιβάζει ΔΩΡΕΑΝ την ψηφιακή σας κληρονομιά",
  concept3_d: "Μετά τον έλεγχο, η Postinity παραδίδει δωρεάν τα ιδιωτικά μηνύματά σας στους παραλήπτες και δημοσιεύει τον φόρο τιμής που ετοιμάσατε.",
  free_h: "Γιατί η προετοιμασία είναι δωρεάν",
  free_p1: "Η προετοιμασία της τελετής μνήμης σας με την Postinity είναι εντελώς δωρεάν, γιατί πιστεύουμε ότι ο καθένας πρέπει να μπορεί να προετοιμάζει, να προστατεύει και να μεταβιβάζει τις αναμνήσεις και τα λόγια του, χωρίς οικονομικούς περιορισμούς όσο ζει. Δεν πληρώνετε τίποτα για να δημιουργήσετε τον χώρο σας, να ετοιμάσετε το κερί, να προσθέσετε φωτογραφίες, βίντεο, μουσική, έγγραφα και ιδιωτικά μηνύματα, να τα αλλάξετε ή να τα διατηρήσετε με ασφάλεια.",
  free_p2: "Ούτε οι τρεις εγγυητές σας πληρώνουν κάτι για να επιβεβαιώσουν τον θάνατό σας και να ξεκινήσουν τη διαδικασία επαλήθευσης.",
  free_p3: "Η Postinity αμείβεται μόνο όταν έρθει η ώρα, κατά τη μετάδοση της τελετής μνήμης και την πραγματική παράδοση των μηνυμάτων σας στους παραλήπτες.",
  free_tag1: "Σήμερα προετοιμάζεστε δωρεάν.",
  free_tag2: "Η Postinity αναλαμβάνει όταν έρθει η ώρα.",
  pricing_link: "Δείτε τις τιμές",
  free_block_title: "Δωρεάν για το άτομο που αφήνει τα μηνύματα",
  free_block_sub: "Δεν πληρώνετε τίποτα για την προετοιμασία",
  card_ceremony: "Η τελετή μου",
  card_message: "Ανά μεμονωμένο μήνυμα",
  free_ceremony_desc: "Ετοιμάστε και αλλάξτε ελεύθερα την τελετή σας, όσο ζείτε.",
  free_message_desc: "Γράψτε και αποθηκεύστε όσα ιδιωτικά μηνύματα θέλετε.",
  pay_btn: "Πληρώνω την τελετή & τα μηνύματα",
  paid_block_title: "Όλα βαρύνουν όσους θελήσουν να δουν τα μηνύματά σας",
  paid_block_sub: "Οι τιμές, με πλήρη διαφάνεια",
  ceremony_paid_desc: "Φύλαξη στο ψηφιακό χρηματοκιβώτιο και μετάδοση της τελετής όταν έρθει η ώρα.",
  message_paid_desc: "Για κάθε ιδιωτικό μήνυμα που παραδίδεται στο άτομο της επιλογής σας.",
  free_footer: "Η προετοιμασία παραμένει δωρεάν — σήμερα δεν πληρώνετε τίποτα.",
  start_btn: "Ετοιμάζω την τελετή μου",
  order_title: "Πληρωμή τελετής & μηνυμάτων",
  order_ceremony_desc: "Μία μόνο τελετή, παραδίδεται στους εγγυητές σας όταν έρθει η ώρα.",
  order_already_paid: "Ήδη πληρωμένη",
  order_messages: "Μεμονωμένα μηνύματα",
  order_per_message: "/ μήνυμα",
  order_bundles: "Προσφορές πακέτου",
  order_bonus: "(+{{n}} δωρεάν)",
  order_total: "Σύνολο προς πληρωμή",
  order_summary: "{{n}} προπληρωμένα μηνύματα",
  order_plus_ceremony: " + τελετή",
  order_note: "Η προπληρωμή δημιουργεί πίστωση: η τελετή και τα μηνύματά σας θα είναι ήδη πληρωμένα, δωρεάν για τους αγαπημένους σας.",
  order_cancel: "Άκυρο",
  order_pay: "Πληρωμή",
  order_success: "Η προπληρωμή καταχωρήθηκε 🎉",
  order_error: "Η πληρωμή απέτυχε",
  credits_some: "{{n}} προπληρωμένα μηνύματα — προσφορά στους αγαπημένους σας",
  credits_none: "Καμία πίστωση: τα νέα μηνύματα βαρύνουν τον παραλήπτη. Προπληρώστε τα για να τα προσφέρετε.",
  credits_buy: "Πληρωμή μηνυμάτων",
};

const hi = {
  back_profile: "प्रोफ़ाइल",
  title: "मैं अपना समारोह तैयार करता/करती हूँ",
  subtitle: "जीते जी अपनी श्रद्धांजलि और संदेश तैयार करें, ताकि अपने प्रियजनों के लिए स्नेह की एक अंतिम साँस छोड़ सकें।",
  concept_h: "अवधारणा",
  concept1_t: "1 — अपना स्मृति समारोह मुफ़्त में तैयार करें",
  concept1_d: "जीते जी अपने अनुरूप एक श्रद्धांजलि बनाएँ: मोमबत्ती, पाठ, तस्वीरें, वीडियो, संगीत, दस्तावेज़ और प्रियजनों के लिए निजी संदेश। आप सब कुछ चुनते हैं और कभी भी मुफ़्त में बदल सकते हैं।",
  concept2_t: "2 — आपके तीन ज़मानतदार मुफ़्त में आपकी इच्छाओं की देखभाल करते हैं",
  concept2_d: "समय आने पर, आपके तीन ज़मानतदार आपके निधन की पुष्टि करते हैं और मुफ़्त में सत्यापन प्रक्रिया शुरू करते हैं।",
  concept3_t: "3 — Postinity आपकी डिजिटल विरासत मुफ़्त में पहुँचाता है",
  concept3_d: "जाँच के बाद, Postinity आपके निजी संदेश उनके प्राप्तकर्ताओं तक मुफ़्त में पहुँचाता है और आपकी तैयार की गई श्रद्धांजलि प्रकाशित करता है।",
  free_h: "तैयारी मुफ़्त क्यों है",
  free_p1: "Postinity के साथ अपना स्मृति समारोह तैयार करना पूरी तरह मुफ़्त है, क्योंकि हमारा मानना है कि हर किसी को जीते जी बिना किसी आर्थिक बोझ के अपनी यादें और शब्द तैयार करने, सुरक्षित रखने और सौंपने में सक्षम होना चाहिए। आप अपना स्थान बनाने, मोमबत्ती तैयार करने, तस्वीरें, वीडियो, संगीत, दस्तावेज़ और निजी संदेश जोड़ने, उन्हें बदलने या सुरक्षित रखने के लिए कुछ भी नहीं देते।",
  free_p2: "आपके तीन ज़मानतदारों को भी आपके निधन की पुष्टि करने और सत्यापन प्रक्रिया शुरू करने के लिए कुछ नहीं देना पड़ता।",
  free_p3: "Postinity को भुगतान केवल समय आने पर मिलता है, जब आपके स्मृति समारोह का प्रसारण और आपके संदेशों की वास्तविक सुपुर्दगी होती है।",
  free_tag1: "आज आप मुफ़्त में तैयारी करते हैं।",
  free_tag2: "समय आने पर Postinity ज़िम्मा संभालता है।",
  pricing_link: "मूल्य देखें",
  free_block_title: "संदेश छोड़ने वाले व्यक्ति के लिए मुफ़्त",
  free_block_sub: "तैयारी के लिए आप कुछ नहीं देते",
  card_ceremony: "मेरा समारोह",
  card_message: "प्रति व्यक्तिगत संदेश",
  free_ceremony_desc: "जीते जी अपना समारोह स्वतंत्र रूप से तैयार करें और बदलें।",
  free_message_desc: "जितने चाहें उतने निजी संदेश लिखें और सहेजें।",
  pay_btn: "मैं समारोह और संदेशों का भुगतान करता/करती हूँ",
  paid_block_title: "सब कुछ उन लोगों पर निर्भर है जो आपके संदेश देखना चाहेंगे",
  paid_block_sub: "मूल्य, पूरी पारदर्शिता के साथ",
  ceremony_paid_desc: "डिजिटल तिजोरी में सुरक्षित और समय आने पर समारोह का प्रसारण।",
  message_paid_desc: "आपके चुने हुए व्यक्ति तक पहुँचाए गए प्रत्येक निजी संदेश के लिए।",
  free_footer: "तैयारी मुफ़्त रहती है — आज आप कुछ नहीं देते।",
  start_btn: "मैं अपना समारोह तैयार करता/करती हूँ",
  order_title: "मेरे समारोह और संदेशों का भुगतान",
  order_ceremony_desc: "एक ही समारोह, समय आने पर आपके ज़मानतदारों को सौंपा जाता है।",
  order_already_paid: "पहले ही भुगतान हो चुका",
  order_messages: "व्यक्तिगत संदेश",
  order_per_message: "/ संदेश",
  order_bundles: "बंडल ऑफ़र",
  order_bonus: "(+{{n}} मुफ़्त)",
  order_total: "कुल भुगतान",
  order_summary: "{{n}} प्रीपेड संदेश",
  order_plus_ceremony: " + समारोह",
  order_note: "प्रीपेमेंट एक क्रेडिट बनाता है: आपका समारोह और संदेश पहले से भुगतान किए होंगे, प्रियजनों के लिए मुफ़्त।",
  order_cancel: "रद्द करें",
  order_pay: "भुगतान करें",
  order_success: "प्रीपेमेंट दर्ज हुआ 🎉",
  order_error: "भुगतान संभव नहीं",
  credits_some: "{{n}} प्रीपेड संदेश — आपके प्रियजनों को भेंट",
  credits_none: "कोई क्रेडिट नहीं: नए संदेशों का भुगतान प्राप्तकर्ता करेगा। भेंट देने के लिए पहले से भुगतान करें।",
  credits_buy: "मेरे संदेशों का भुगतान करें",
};

const ja = {
  back_profile: "プロフィール",
  title: "私のセレモニーを準備します",
  subtitle: "生前に追悼とメッセージを準備し、大切な人へ最後のやさしさのひと息を残しましょう。",
  concept_h: "コンセプト",
  concept1_t: "1 — 追悼セレモニーを無料で準備",
  concept1_d: "生前に、あなたらしい追悼を作成します：キャンドル、テキスト、写真、動画、音楽、書類、そして大切な人への非公開メッセージ。すべてをあなたが選び、いつでも無料で変更できます。",
  concept2_t: "2 — 3人の保証人が無料であなたの意思を見守ります",
  concept2_d: "その時が来たら、3人の保証人があなたの逝去を確認し、無料で確認手続きを開始します。",
  concept3_t: "3 — Postinity があなたのデジタル遺産を無料で引き継ぎます",
  concept3_d: "確認後、Postinity は非公開メッセージを受取人へ無料で届け、あなたが準備した追悼を公開します。",
  free_h: "準備が無料である理由",
  free_p1: "Postinity での追悼セレモニーの準備は完全に無料です。誰もが生前に、経済的な制約なく思い出や言葉を準備・保護・継承できるべきだと考えるからです。スペースの作成、キャンドルの準備、写真・動画・音楽・書類・非公開メッセージの追加や編集、安全な保管に費用は一切かかりません。",
  free_p2: "3人の保証人も、逝去の確認や確認手続きの開始に費用はかかりません。",
  free_p3: "Postinity が報酬を受け取るのはその時が来たとき、追悼セレモニーの配信とメッセージの実際の受取人への配信のときだけです。",
  free_tag1: "今日は無料で準備します。",
  free_tag2: "その時が来たら Postinity が引き継ぎます。",
  pricing_link: "料金を見る",
  free_block_title: "メッセージを残す人は無料",
  free_block_sub: "準備に費用はかかりません",
  card_ceremony: "私のセレモニー",
  card_message: "個別メッセージごと",
  free_ceremony_desc: "生前に、自由にセレモニーを準備・編集できます。",
  free_message_desc: "非公開メッセージを好きなだけ書いて保存できます。",
  pay_btn: "セレモニーとメッセージを支払う",
  paid_block_title: "すべては、あなたのメッセージを見たい人が負担します",
  paid_block_sub: "料金は完全に透明です",
  ceremony_paid_desc: "デジタル金庫に保管し、その時が来たらセレモニーを配信します。",
  message_paid_desc: "選んだ相手に届けられる各非公開メッセージにつき。",
  free_footer: "準備は無料のまま — 今日は何も支払いません。",
  start_btn: "私のセレモニーを準備します",
  order_title: "セレモニーとメッセージの支払い",
  order_ceremony_desc: "セレモニーは1つのみ。その時が来たら保証人へ届けられます。",
  order_already_paid: "支払い済み",
  order_messages: "個別メッセージ",
  order_per_message: "/ メッセージ",
  order_bundles: "パック特典",
  order_bonus: "（+{{n}} 無料）",
  order_total: "お支払い合計",
  order_summary: "{{n}} 件の前払いメッセージ",
  order_plus_ceremony: " ＋ セレモニー",
  order_note: "前払いはクレジットを作成します：セレモニーとメッセージは支払い済みとなり、大切な人には無料です。",
  order_cancel: "キャンセル",
  order_pay: "支払う",
  order_success: "前払いを登録しました 🎉",
  order_error: "支払いができません",
  credits_some: "{{n}} 件の前払いメッセージ — 大切な人への贈り物",
  credits_none: "クレジットがありません：新しいメッセージは受取人負担になります。贈るには前払いしてください。",
  credits_buy: "メッセージを支払う",
};

const zh = {
  back_profile: "个人资料",
  title: "我准备我的仪式",
  subtitle: "在生前准备好您的悼念与留言，为您所爱的人留下最后一缕温柔。",
  concept_h: "理念",
  concept1_t: "1 — 免费准备您的纪念仪式",
  concept1_d: "在生前，按您的意愿创建一份悼念：蜡烛、文字、照片、视频、音乐、文件以及给亲人的私人留言。一切由您选择，随时可免费修改。",
  concept2_t: "2 — 三位担保人免费守护您的意愿",
  concept2_d: "到时候，您的三位担保人确认您的离世并免费启动核实程序。",
  concept3_t: "3 — Postinity 免费传递您的数字遗产",
  concept3_d: "核实后，Postinity 免费将您的私人留言送达收件人，并发布您准备的悼念。",
  free_h: "为什么准备是免费的",
  free_p1: "使用 Postinity 准备您的纪念仪式完全免费，因为我们相信每个人都应能够在生前无经济负担地准备、保护并传递自己的回忆与话语。创建空间、准备蜡烛、添加照片、视频、音乐、文件和私人留言，修改或安全保存，您无需支付任何费用。",
  free_p2: "您的三位担保人确认您的离世并启动核实程序同样无需付费。",
  free_p3: "Postinity 仅在到时候才收取费用，即在播放您的纪念仪式并将留言实际送达收件人时。",
  free_tag1: "今天您免费准备。",
  free_tag2: "到时候由 Postinity 接手。",
  pricing_link: "查看价格",
  free_block_title: "留言者免费",
  free_block_sub: "准备无需付费",
  card_ceremony: "我的仪式",
  card_message: "每条单独留言",
  free_ceremony_desc: "在生前自由准备并修改您的仪式。",
  free_message_desc: "随心撰写并保存任意数量的私人留言。",
  pay_btn: "我支付仪式和留言",
  paid_block_title: "一切由希望查看您留言的人承担",
  paid_block_sub: "价格，完全透明",
  ceremony_paid_desc: "存入数字保险库，并在到时候播放您的仪式。",
  message_paid_desc: "每条送达您所选之人的私人留言。",
  free_footer: "准备始终免费 — 今天您无需付费。",
  start_btn: "我准备我的仪式",
  order_title: "支付我的仪式和留言",
  order_ceremony_desc: "仅一场仪式，到时候送达您的担保人。",
  order_already_paid: "已支付",
  order_messages: "单独留言",
  order_per_message: "/ 条留言",
  order_bundles: "套餐优惠",
  order_bonus: "（+{{n}} 免费）",
  order_total: "应付总额",
  order_summary: "{{n}} 条预付留言",
  order_plus_ceremony: " + 仪式",
  order_note: "预付将生成一份额度：您的仪式和留言将已付款，对您的亲人免费。",
  order_cancel: "取消",
  order_pay: "支付",
  order_success: "预付已记录 🎉",
  order_error: "无法支付",
  credits_some: "{{n}} 条预付留言 — 赠予您的亲人",
  credits_none: "没有额度：新留言将由收件人承担。预付以将其赠出。",
  credits_buy: "支付我的留言",
};

export const postinity = { fr, en, es, de, it, pl, fil, ru, el, hi, ja, zh };
